import { State } from '../../interfaces/State';
import { LearningRecapState } from '../reducers/learningRecap';

export const selectLearningRecap = (state: State): LearningRecapState =>
  state.get('learningRecap');
